// Constants
import {
  INPUT_OTP_BUTTON_PROPS,
  INPUT_OTP_INPUT_CLEAR_ICON_PROPS,
  INPUT_OTP_INPUT_PROPS,
  SNACKBAR_PROPS,
} from '../constants/contract-otp.constants';
// Translations
import translations from '../translations/contract-otp.translations';
// Types
import { InputOTPType, SnackbarComponentType } from '@openbank/ziniaweb-ui-components';
import {
  InputOtpConfigurationType,
  SnackBarConfigurationType,
} from './types/contract-otp.configurations.types';

const inputOtpConfiguration = ({
  formatMessage,
  handleChangeOtpCode,
  handleClearOtp,
  handleResendOtp,
  handleTextboxClickTracking,
  otpInfo,
  verifyInfo,
}: InputOtpConfigurationType): InputOTPType => ({
  input: {
    ...INPUT_OTP_INPUT_PROPS,
    error: verifyInfo.showAttemptsWarning && verifyInfo.msg !== null,
    errorMessage: verifyInfo.msg || '',
    label: formatMessage({ id: translations.ENTER_YOUR_CODE }),
    onChange: e => {
      handleChangeOtpCode(e);
    },
    onClick: () => {
      handleTextboxClickTracking();
    },
    rightIcon: otpInfo.code
      ? {
          ...INPUT_OTP_INPUT_CLEAR_ICON_PROPS,
          altText: formatMessage({ id: translations.CLEAR }),
          onClick: () => {
            handleClearOtp();
          },
        }
      : undefined,
    value: otpInfo.code,
  },
  button: {
    ...INPUT_OTP_BUTTON_PROPS,
    children: formatMessage({ id: translations.REQUEST_A_NEW_CODE }),
    onClick: () => {
      handleTextboxClickTracking();
      handleResendOtp();
    },
    disabled: otpInfo.attempts === null || otpInfo.attempts <= 0 || otpInfo.disabled,
  },
  variant: 'DEFAULT' as any,
});

const snackbarConfiguration = ({
  otpInfo: { error, open, msg },
  handleOpenCloseSnackbar,
}: SnackBarConfigurationType): SnackbarComponentType => ({
  ...SNACKBAR_PROPS,
  onOpenClose: isOpen => {
    handleOpenCloseSnackbar(isOpen);
  },
  icon: { icon: error ? 'icon_symbols_alert' : 'icon_symbols_checkmark-in-a-circle' },
  open,
  title: msg,
  type: (error ? 'ERROR' : 'SUCCESS') as any,
});

export { inputOtpConfiguration, snackbarConfiguration };
